import { createSlice } from '@reduxjs/toolkit';
import { getEmployerData, validateEmployerProvidedIncome, searchEmployers } from 'thunks';
import { Employer, EmployerData } from 'api/EmployersApi';
import { LinkSearchKindType } from 'enums/LinkSearchKindType';

type SearchTerm = string;

interface EmployersState {
  searchTerm: SearchTerm;
  searchResults: Partial<Record<SearchTerm, Employer[]>>;
  searchKind: LinkSearchKindType | null;
  getEmployerData: {
    isLoading: boolean;
    error: boolean;
    employerData: EmployerData | null;
  };
  validateEmployerProvidedIncome: {
    isLoading: boolean;
    error: boolean;
    incomeRequired: boolean | null;
  };
}

const initialState: EmployersState = {
  searchTerm: '',
  searchResults: {},
  searchKind: null,
  getEmployerData: {
    isLoading: false,
    error: false,
    employerData: null,
  },
  validateEmployerProvidedIncome: {
    isLoading: false,
    error: false,
    incomeRequired: null,
  },
};

const employers = createSlice({
  name: 'employers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(searchEmployers.pending, (state, action) => {
      const searchParams = action.meta.arg;
      state.searchTerm = searchParams.name;
      if (state.searchKind !== searchParams.kind) {
        state.searchKind = searchParams.kind;
        state.searchResults = {};
      }
    });

    builder.addCase(searchEmployers.fulfilled, (state, action) => {
      const searchParams = action.meta.arg;
      state.searchResults[searchParams.name] = action.payload;
    });

    builder.addCase(getEmployerData.pending, (state) => {
      state.getEmployerData.isLoading = true;
      state.getEmployerData.error = false;
    });
    builder.addCase(getEmployerData.fulfilled, (state, action) => {
      state.getEmployerData.isLoading = false;
      state.getEmployerData.employerData = action.payload;
    });
    builder.addCase(getEmployerData.rejected, (state) => {
      state.getEmployerData.isLoading = false;
      state.getEmployerData.error = true;
    });
    builder.addCase(validateEmployerProvidedIncome.pending, (state) => {
      state.validateEmployerProvidedIncome.isLoading = true;
      state.validateEmployerProvidedIncome.error = false;
    });
    builder.addCase(validateEmployerProvidedIncome.fulfilled, (state, action) => {
      const { incomeRequired } = action.payload;

      state.validateEmployerProvidedIncome.isLoading = false;
      state.validateEmployerProvidedIncome.incomeRequired = incomeRequired;
    });
    builder.addCase(validateEmployerProvidedIncome.rejected, (state) => {
      state.validateEmployerProvidedIncome.isLoading = false;
      state.validateEmployerProvidedIncome.error = true;
    });
  },
});

export default employers.reducer;
